import React from 'react';
import _ from 'underscore';
import { Formik, Form, Field, FieldArray } from 'formik';
import { Button, Grid, Divider, Segment, Header, Input, Dimmer, Loader } from 'semantic-ui-react';
import moment from 'moment'

import FormsInputsText from '../../../forms/inputs/text/forms_inputs_text';
import FormsInputsEmail from '../../../forms/inputs/email/forms_inputs_email';
import FormsInputDropdown from '../../../forms/inputs/dropdown';
import CommonUtility from '../../../../utils/CommonUtility';
import ListClientSelection from '../../client/list_client_selection';
import { USER_TYPE, USER_ROLES } from '../../../../constants';
import { getSystemAdminClients } from '../../../../actions'

const genderLetterOptions = [
    { text: 'Male', value: 'm' },
    { text: 'Female', value: 'f' }
];

const filterOptions = [
    { key: 'companyName', text: 'Company Name', value: 'name' }, 
    { key: 'groupCode', text: 'Group Code', value: 'groupCode' },
    { key: 'policyNo', text: 'Policy No', value: 'policyNo' },
]

class UserFormBasicInformation extends React.Component {

    state = {
        openModalSelectCompany: true,
        currentPage: 1,
        perPage: 10,
        totalPage: 1,
        totalData: 1,
        filter: 'name',
        query: '',
        clients: [],
        companyName:null,
        groupCode:null,
        policyNo:null,
        isLoading:false,
        isSearch: false
    }

    componentDidMount(){
        if(this.props.admin && this.state.clients.length === 0){
            this.getClients()
        }
    }

    getClients = () => {
        const { accessToken } = this.props.admin;

        let params = {}

        if (this.state.query !== '') {
            params[this.state.filter] = this.state.query
        }

        getSystemAdminClients({
            accessToken,
            searchPage: this.state.currentPage,
            searchMax: this.state.perPage,
            params
        }, (result, error) => {
            if(result && result.data) {
                if(result.data.pagination) {
                    this.setState({
                        totalPage: result.data.pagination.totalPage,
                        totalData: result.data.pagination.totalData,
                        isLoading: false, 
                    })
                }
                if(result.data.clients) {
                    this.setState({
                        clients: result.data.clients,
                        isLoading: false 
                    })
                }
            }
        });
    }

    showCompanyDialog(isShow) {
        if (isShow) {
            this.setState({
                ...this.state,
                openModalSelectCompany: true,
            })
        } else {
            this.setState({
                ...this.state,
                openModalSelectCompany: false,
            })
        }
    }

    onSelectCompany(companyId, companyName, formikData){
        formikData.setFieldValue("companyName", companyName);
        formikData.setFieldValue("companyCode", companyId)
        this.showCompanyDialog(false);
    }

    submitFilter = () => {
        if (this.state.query !== '') {
            this.setState({...this.state, isLoading: true, currentPage: 1}, () => {
                this.getClients();
            });
        }
    }

    clearFilter = () => {
        this.setState({ query: '', isLoading: true, isSearch:false }, () => {
            this.getClients();
        });
    }

    checkClearFilter = (e) => {
        console.log('e.target.value: ', e.target.value)
        if(e.target.value === "" || e.target.value === null){
            this.setState({ query: '', isLoading: true }, () => {
                this.getClients();
            });
        }
        this.setState({ query: e.target.value })
    }

    goToPreviousPage = () => {
        if (this.state.currentPage > 1) {
            this.setState({ isLoading: true, currentPage: this.state.currentPage - 1 }, () => {
                this.getClients();
            });
        };
    }

    goToNextPage = () => {
        let clientLength = this.state.clients ? this.state.clients : this.props.clients
        if (clientLength.length >= this.state.perPage) {
            this.setState({ isLoading: true, currentPage: this.state.currentPage + 1 }, () => {
                this.getClients();
            });
        };
    }

    setPage = (num) => {
        this.setState({ currentPage: num, isLoading: true, }, () => {
            this.getClients();
        });
    }

    setPerPage = (num) => {
        this.setState({ perPage: num, isLoading: true, currentPage: 1 }, () => {
            this.getClients();
        });
    }

    onFilterDropdownChange = (e,{name, value}) => {    
        if(e.target.value === ""){
            this.setState({ filter: '' })
        } else {
            this.setState({ filter: value });
        }
    }

    render() {

        const { user, company } = this.props;
        const isAdminOperation = CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, this.props.admin) && CommonUtility.haveRoles([USER_ROLES.ADMIN_OPERATION], this.props.admin);
        const isAdminCallCentre = CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, this.props.admin) && CommonUtility.haveRoles([USER_ROLES.ADMIN_CALL_CENTRE], this.props.admin);

        return (
            <Formik
                initialValues={{
                    uuid: user.uuid,
                    companyName: user.companyName,
                    companyCode: user.companyId,
                    nric: user.nric,
                    name: user.name,
                    email: user.email,
                    birthdate: user.birthdate && moment(user.birthdate).format('YYYY-MM-DD'),
                    effectiveStartDate: user.effectiveStartDate && moment(user.effectiveStartDate).format('YYYY-MM-DD'),
                    effectiveEndDate: user.effectiveEndDate && moment(user.effectiveEndDate).format('YYYY-MM-DD'),
                    gender: user.gender,
                    contactNoCountryCode: user.contactNoCountryCode,
                    contactNo: user.contactNo,
                    created: user.created ? moment(user.created).format('DD/MM/YYYY - HH:mm Z') : "",
                    updated: user.updated ? moment(user.updated).format('DD/MM/YYYY - HH:mm Z') : "",
                    updatedBy: user.updatedBy,
                    version: user.version,
                }}
                validateOnChange={false}
                validateOnBlur={false}
                // validationSchema={OutpatientValidationSchema}
                onSubmit={this.props.onSubmit}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue
                }) => {

                    // Show loading UI
                    if(isSubmitting){
                        return ( <Dimmer active inverted><Loader>Loading</Loader></Dimmer>)
                    }

                    return (
                        <Segment>
                            <Form>

                                {!this.props.user.uuid && 
                                    <ListClientSelection
                                        open={ this.state.openModalSelectCompany }
                                        clients={this.state.clients}
                                        onSelectCompany={ (compId, compName) => {
                                            this.onSelectCompany(compId, compName, {setFieldValue});
                                        }}
                                        onClose={()=>{ this.showCompanyDialog(false) }}
                                        currentPage={this.state.currentPage }
                                        perPage={this.state.perPage }
                                        totalPage={this.state.totalPage }
                                        totalData={this.state.totalData }
                                        filter={this.state.filter}
                                        query={this.state.query} 
                                        submitFilter={ this.submitFilter.bind(this) }
                                        clearFilter={ this.clearFilter.bind(this) }
                                        checkClearFilter={this.checkClearFilter.bind(this)}

                                        goToPreviousPage={ this.goToPreviousPage.bind(this) }
                                        goToNextPage={ this.goToNextPage.bind(this) }
                                        setPage={ this.setPage.bind(this) }
                                        setPerPage={ this.setPerPage.bind(this) }

                                        onFilterDropdownChange={this.onFilterDropdownChange.bind(this)}
                                        filterOptions={filterOptions}
                                        isLoading={this.state.isLoading}
                                        // isSearch={this.state.isSearch}
                                    />
                                }

                                <Grid container columns={2}>
                                    <Grid.Column width={16}>
                                        <Divider horizontal style={{ margin: "13px 0 30px 0" }}> <Header as='h3'>Basic Information</Header></Divider>
                                    </Grid.Column>

                                    {!values.uuid &&
                                        <Grid.Column width={16}>
                                            <Field name={`companyName`} label="Company Name" secondaryLabel="" >
                                                {({ field }) => (
                                                    <>
                                                        <Header as='h5'>Company Name</Header>
                                                        <Input fluid {...field}  labelPosition='right' placeholder='Select Company' content="Select Company" readOnly={true} label={
                                                            <Button type="button" onClick={() => { this.showCompanyDialog(true) }}>Select Company</Button>
                                                        } />
                                                    </>
                                                )}
                                            </Field>
                                        </Grid.Column>
                                    }

                                    {this.props.showDetail &&
                                        <Grid.Column>
                                            <Field name="uuid" label="User ID" component={FormsInputsText} secondaryLabel="" className="uppercase" disabled={true} />
                                        </Grid.Column>
                                    }
                                    <Grid.Column>
                                        <Field name="nric" label="NRIC" component={FormsInputsText} secondaryLabel="" placeholder="Enter NRIC" className="uppercase" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="name" label="Name" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="birthdate" label="Birthdate" component={FormsInputsText} secondaryLabel="" type="date" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="gender" label="Gender" component={FormsInputDropdown} options={genderLetterOptions} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    {!values.uuid &&
                                        <Grid.Column>
                                            <Field name="effectiveStartDate" label="Effective Start Date" component={FormsInputsText} secondaryLabel="" type="date" disabled={!isAdminOperation} />
                                        </Grid.Column>
                                    }
                                    {!values.uuid &&
                                        <Grid.Column>
                                            <Field name="effectiveEndDate" label="Effective End Date" component={FormsInputsText} secondaryLabel="" type="date" disabled={!isAdminOperation} />
                                        </Grid.Column>
                                    }
                                    <Grid.Column>
                                        <Field name="contactNoCountryCode" label="Country Code" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field name="contactNo" label="Contact Number" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                    </Grid.Column>
                                    {this.props.showDetail &&
                                        <React.Fragment>
                                            <Grid.Column width={16}>
                                                <Divider horizontal style={{ margin: "40px 0 20px 0" }}> <Header as='h3'>System Generated Data</Header></Divider>
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Field name="created" label="Created Date" component={FormsInputsText} secondaryLabel="" disabled={true} />
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Field name="updated" label="Updated Date" component={FormsInputsText} secondaryLabel="" disabled={true} />
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Field name="updatedBy" label="Last Updated By User ID" component={FormsInputsText} secondaryLabel="" disabled={true} />
                                            </Grid.Column>
                                            <Grid.Column>
                                                <Field name="version" label="Data Version" component={FormsInputsText} secondaryLabel="" disabled={true} />
                                            </Grid.Column>
                                        </React.Fragment>
                                    }

                                    {(isAdminOperation) &&
                                        <Grid.Column width={16}>
                                            <Button
                                                loading={isSubmitting}
                                                type="submit"
                                                primary
                                                disabled={isSubmitting}
                                                fluid
                                                size="big"
                                            >
                                                {this.props.submitText}
                                        </Button>
                                        </Grid.Column>
                                    }

                                    <Grid.Column width={16}>
                                        {this.props.renderSubmitResult instanceof Function && this.props.renderSubmitResult()}
                                    </Grid.Column>
                                </Grid>
                            </Form>
                        </Segment>
                    )
                }}
            >

            </Formik>
        )
    }

}

UserFormBasicInformation.defaultProps = {
    clients: [],
    user: {},
    company: {},
    admin: {},
    onSubmit: undefined,
    showDetail: true,
    renderSubmitResult: undefined,
    submitText: "Save"
}

export default UserFormBasicInformation;

